const config = {
  apiUrl: 'https://dev-api.logirate.org/',
  callbackUrlBase: 'https://dev-api.logirate.org/',
};

export default config;
